import * as React from 'react';
import DismissableRightSidebar from 'general-ledger/DismissableRightSidebar';
import { useGeneralLedger } from 'general-ledger/fast-gl/hooks/useGeneralLedger';
import { LedgerAccountSidebar } from 'bk-web-app/ledger-account-sidebar';
import { JournalEntrySidebar } from 'journal-entry-sidebar';

export const RightSidebars = () => {
  const { sidebarDescriptor, selectedLedgerAccount, selectedJournalEntry, clearSidebar } =
    useGeneralLedger();

  if (!sidebarDescriptor) return null;

  return (
    <DismissableRightSidebar clearSidebar={clearSidebar}>
      {sidebarDescriptor.sidebarType === 'LEDGER_ACCOUNT' ? (
        <LedgerAccountSidebar dismiss={clearSidebar} ledgerAccountId={selectedLedgerAccount?.id} />
      ) : null}
      {sidebarDescriptor.sidebarType === 'JOURNAL_ENTRY' ? (
        <JournalEntrySidebar dismiss={clearSidebar} journalEntryId={selectedJournalEntry?.id} />
      ) : null}
    </DismissableRightSidebar>
  );
};
